export enum SearchModes {
    Multiple ='multiple',
    Tags = 'tags',
}